// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  border: 1px solid #b9b9c3;
  position: relative;
  padding: 20px;
  margin-top: 20px;
  /* Adjust based on label height to ensure spacing */
  border-radius: 4px;
}

.section-label {
  position: absolute;
  top: -10px;
  /* Half of font-size, adjust if the label font-size changes */
  left: 20px;
  /* Align with padding of .section-content or as desired */
  background-color: #fff;
  /* Match the background of the container of .section */
  padding: 0 10px;
  color: initial;
}

.delete-icon {
  margin-left: 8px;
  /* Adjust the space as needed */
  cursor: pointer;
  color: red;
  /* Give it a default color to indicate it can be interacted with */
  transition: color 0.3s;
  /* A transition for when the color changes, if you want */
}
.delete-icon:hover {
  color: darkred;
  /* A different color on hover to indicate it's clickable */
}`, "",{"version":3,"sources":["webpack://./src/components/general/SectionWithLabel.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EAAkB,mDAAA;EAClB,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EAAY,6DAAA;EACZ,UAAA;EAAY,yDAAA;EACZ,sBAAA;EAAwB,sDAAA;EACxB,eAAA;EACA,cAAA;AAGF;;AAGA;EACE,gBAAA;EAAkB,+BAAA;EAClB,eAAA;EACA,UAAA;EAAY,kEAAA;EACZ,sBAAA;EAAwB,yDAAA;AAG1B;AADE;EACE,cAAA;EAAgB,0DAAA;AAIpB","sourcesContent":["@import '../../@core/scss/base/bootstrap-extended/variables';\n\n.section {\n  border: 1px solid $text-muted;\n  position: relative;\n  padding: 20px;\n  margin-top: 20px; /* Adjust based on label height to ensure spacing */\n  border-radius: 4px;\n}\n\n.section-label {\n  position: absolute;\n  top: -10px; /* Half of font-size, adjust if the label font-size changes */\n  left: 20px; /* Align with padding of .section-content or as desired */\n  background-color: #fff; /* Match the background of the container of .section */\n  padding: 0 10px;\n  color: initial;\n}\n\n.section-content {\n}\n\n.delete-icon {\n  margin-left: 8px; /* Adjust the space as needed */\n  cursor: pointer;\n  color: red; /* Give it a default color to indicate it can be interacted with */\n  transition: color 0.3s; /* A transition for when the color changes, if you want */\n\n  &:hover {\n    color: darkred; /* A different color on hover to indicate it's clickable */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
